<template>
  <div v-if="rules" class="listing-rules grey lighten-3 py-6">
    <v-container>
      <h2 class="text-h5 mb-7">{{ $t("house_rules") }}</h2>
      <v-row>
        <v-col
          v-for="(item, index) in rules"
          :key="`rule-${index}`"
          cols="12"
          md="6"
        >
          <div class="listing-rules-item d-flex">
            <div class="listing-rules-item-icon mr-4 pt-1">
              <v-icon>{{ item.icon }}</v-icon>
            </div>
            <div class="listing-rules-item-content">
              <h3
                class="text-h6 font-weight-semibold mb-2"
                v-text="item.title"
              />
              <div v-text="item.text" />
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "listing-rules",
  props: {
    rules: Object,
  },
};
</script>

<style scoped></style>
